import { computed as a, openBlock as s, createBlock as j, resolveDynamicComponent as k, normalizeProps as v, guardReactiveProps as b, withCtx as C, createElementBlock as l, Fragment as g, renderList as S, normalizeClass as P, toDisplayString as u, createTextVNode as T } from "vue";
import { themeProp as _ } from "../../composables/useTheme.js";
import $ from "../../utils/validators/screen.js";
import p from "../../constants/screen.js";
const D = "DsHighlightedTitle", N = /* @__PURE__ */ Object.assign({
  name: D
}, {
  __name: "highlighted-title",
  props: {
    ..._,
    /**
     * title text
     */
    text: {
      type: String,
      required: !0
    },
    /**
     * title html tag
     */
    tag: {
      type: String,
      default: "h1",
      validator: (r) => ["h1", "h2", "h3", "h4", "h5", "h6"].includes(r)
    },
    /**
     * title size
     */
    size: {
      type: [String, Object],
      default: "",
      validator: (r) => typeof r == "string" ? ["", "xsmall", "small", "medium", "large", "xlarge"].includes(r) : typeof r == "object" ? $(r) : !1
    }
  },
  setup(r) {
    const o = r, d = (t) => {
      if (typeof t == "string")
        return t ? `ds-heading-${t}` : "ds-heading";
      if (typeof t == "object")
        return Object.keys(t).reduce((n, e) => {
          const i = p[e].prefix ? `-${p[e].prefix}` : "", c = p[e] ? `-${t[e]}` : "";
          return n += `ds${i}-heading${c} `, n;
        }, "");
    }, h = a(() => ({
      class: d(o.size)
    })), f = a(() => o.theme === "green" ? "ds-color-black" : "ds-color-green"), x = /\{\{(.*?)\}\}/g, m = a(() => o.text.match(x)), y = a(() => {
      if (!m.value)
        return [o.text];
      const t = m.value.reduce(
        (n, e) => {
          const [i, ...c] = n.remaining.split(e);
          return n.parts.push(i, {
            text: e.replace(/{{|}}/g, "")
          }), n.remaining = c.join(e), n;
        },
        { remaining: o.text, parts: [] }
      );
      return t.parts.concat(t.remaining);
    });
    return (t, n) => (s(), j(k(r.tag), v(b(h.value)), {
      default: C(() => [
        (s(!0), l(g, null, S(y.value, (e, i) => (s(), l(g, { key: i }, [
          typeof e == "object" ? (s(), l("span", {
            key: 0,
            class: P(f.value),
            "data-j-highlight": ""
          }, u(e.text), 3)) : (s(), l(g, { key: 1 }, [
            T(u(e), 1)
          ], 64))
        ], 64))), 128))
      ]),
      _: 1
    }, 16));
  }
}), R = N;
export {
  R as default
};
